module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[32]519.a872dcc.woff2";